<div class="text-center my-2" *ngIf="config.id">
  <pagination-template
    #p="paginationApi"
    [id]="config.id"
    (pageChange)="onPageChange($event)"
  >
    <div class="custom-pagination">
      <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
        <img
          src="../../../../assets/images/pagination_assets/arrow_previous_inactive.png"
          alt="previous inactive icon"
          *ngIf="p.isFirstPage()"
        />
        <img
          src="../../../../assets/images/pagination_assets/arrow_previous_active.png"
          alt="previous active icon"
          (click)="p.previous()"
          *ngIf="!p.isFirstPage()"
        />
      </div>
      <div
        class="page-number"
        *ngFor="let page of p.pages"
        [class.current]="p.getCurrent() === page.value"
      >
        <span
          (click)="p.setCurrent(page.value)"
          *ngIf="p.getCurrent() !== page.value"
          >{{ page.label }}</span
        >
        <div *ngIf="p.getCurrent() === page.value">
          <span>{{ page.label }}</span>
        </div>
      </div>
      <div class="pagination-next" [class.disabled]="p.isLastPage()">
        <img
          src="assets/images/pagination_assets/arrow_next_inactive.png"
          alt="next inactive icon"
          *ngIf="p.isLastPage()"
        />
        <img
          src="assets/images/pagination_assets/arrow_next_active.png"
          alt="next active icon"
          (click)="p.next()"
          *ngIf="!p.isLastPage()"
        />
      </div>
    </div>
  </pagination-template>
</div>
